import { render, staticRenderFns } from "./DeviceManagementDetails.vue?vue&type=template&id=38494d90&scoped=true&"
import script from "./DeviceManagementDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38494d90",
  null
  
)

export default component.exports